import React from 'react';
import { Link } from 'react-router-dom';
import { useWishlist } from '../context/WishlistContext';
import { useCart } from '../context/CartContext';
import { useToast } from '../context/ToastContext';
import { getProductImageUrl } from '../utils/productImage';

const C = { primary: '#8B1A1A', gold: '#D4A017' };

export default function Wishlist() {
  const { items, dispatch } = useWishlist();
  const { dispatch: cartDispatch } = useCart();
  const { addToast } = useToast();

  const moveToCart = (product) => {
    cartDispatch({ type: 'ADD_ITEM', payload: { product, quantity: 1 } });
    dispatch({ type: 'REMOVE', payload: product.id });
    addToast(`${product.name} moved to cart`, 'success');
  };

  const removeItem = (product) => {
    dispatch({ type: 'REMOVE', payload: product.id });
    addToast(`${product.name} removed from wishlist`, 'info');
  };

  if (items.length === 0) {
    return (
      <div style={{ minHeight: '55vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '60px 24px', textAlign: 'center' }}>
        <div style={{ fontSize: 56, marginBottom: 16 }}>♡</div>
        <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 26, color: '#2C2C2C', marginBottom: 10 }}>Your wishlist is empty</h2>
        <p style={{ color: '#888', marginBottom: 28 }}>Save items you love by clicking the heart on any product.</p>
        <Link to="/shop" style={{ background: C.primary, color: '#fff', textDecoration: 'none', padding: '12px 28px', borderRadius: 4, fontSize: 15, fontWeight: 600 }}>
          Browse Products
        </Link>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 1100, margin: '0 auto', padding: '40px 24px' }}>
      <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: 32, color: '#2C2C2C', marginBottom: 8 }}>My Wishlist</h1>
      <p style={{ color: '#888', marginBottom: 28, fontSize: 14 }}>{items.length} item{items.length !== 1 ? 's' : ''} saved</p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 24 }}>
        {items.map(product => {
          const imageUrl = getProductImageUrl(
            product,
            'https://placehold.co/400x500/8B1A1A/gold?text=A1+Looks'
          );
          return (
            <div key={product.id} style={{ background: '#fff', borderRadius: 8, overflow: 'hidden', boxShadow: '0 2px 12px rgba(0,0,0,0.07)', position: 'relative' }}>
              <Link to={`/product/${product.slug}`} style={{ textDecoration: 'none' }}>
                <img src={imageUrl} alt={product.name} style={{ width: '100%', height: 260, objectFit: 'cover', display: 'block' }} />
                <div style={{ padding: '14px 14px 0' }}>
                  <p style={{ fontSize: 12, color: '#888', marginBottom: 4 }}>{product.category_name}</p>
                  <h3 style={{ fontFamily: "'Playfair Display', serif", fontSize: 15, color: '#2C2C2C', marginBottom: 8, lineHeight: 1.4 }}>{product.name}</h3>
                  <p style={{ fontSize: 16, fontWeight: 700, color: C.primary, marginBottom: 14 }}>
                    ₹{Math.round(parseFloat(product.effective_price || product.price)).toLocaleString('en-IN')}
                  </p>
                </div>
              </Link>
              <div style={{ padding: '0 14px 14px', display: 'flex', gap: 8 }}>
                <button
                  onClick={() => moveToCart(product)}
                  disabled={!product.in_stock}
                  style={{ flex: 1, padding: '9px 0', background: product.in_stock ? C.primary : '#ccc', color: '#fff', border: 'none', borderRadius: 4, fontSize: 13, fontWeight: 600, cursor: product.in_stock ? 'pointer' : 'not-allowed' }}
                >
                  {product.in_stock ? 'Move to Cart' : 'Out of Stock'}
                </button>
                <button
                  onClick={() => removeItem(product)}
                  style={{ padding: '9px 12px', background: '#fff', color: '#e53935', border: '1.5px solid #e53935', borderRadius: 4, fontSize: 13, cursor: 'pointer', fontWeight: 600 }}
                  title="Remove"
                >✕</button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
